import { mergeAttributes, Node } from '@tiptap/core';

export const PdfComponentExt = Node.create({
  name: 'pdfComponent',
  atom: true,
  draggable: true,
  group: 'block',
  inline: false,
  selectable: true,

  parseHTML() {
    return [
      {
        tag: `div[data-type="${this.name}"]`,
        priority: 51,
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'pdf-component',
      mergeAttributes(HTMLAttributes, {
        width: HTMLAttributes['data-media-width'],
        height: HTMLAttributes['data-media-height'],
        align: HTMLAttributes['data-align'],
        url: HTMLAttributes['fileUrl'],
        name: HTMLAttributes['fileName'],
        origin: HTMLAttributes['origin'],
      }),
    ];
  },

  addAttributes() {
    return {
      fileUrl: {
        default: '',
      },
      fileName: {
        default: '',
      },
      origin: {
        default: 'distribute-staging.com',
      },
      'data-media-width': {
        default: null,
      },
      'data-media-height': {
        default: null,
      },
      'data-align': {
        default: 'center',
      },
    };
  },
});
